import axiosLimiter from '@/api/RateLimiter';

const farFutureDateISOString = new Date(9999, 1, 1).toISOString();

export default {
  async getAllCollectionPages(
    tenantUUID: string,
    params: any = {}
  ): Promise<any[]> {
    const requests: Promise<any>[] = [];
    let currentPage = 1;
    let totalPages: number | null = null;
    let nextPageLink: string | null = null;

    while (totalPages === null || currentPage < totalPages + 1) {
      let requestURL =
        process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenantUUID +
        '/rules?';

      // Filters
      if ('createdFrom' in params && params.createdFrom && params.createdFrom.length > 0) {
        requestURL += '&createdFrom=' + encodeURIComponent(params.createdFrom);
      }
      if ('createdUntil' in params && params.createdUntil && params.createdUntil.length > 0) {
        requestURL +=
          '&createdUntil=' + encodeURIComponent(params.createdUntil);
      }
      if ('deleted' in params && params.deleted) {
        requestURL +=
          '&deletedUntil=' + encodeURIComponent(farFutureDateISOString);
      }

      // Pagination
      if (nextPageLink) {
        requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + nextPageLink;
      }

      const response: Promise<any> = axiosLimiter.get(requestURL);

      if (totalPages === null || currentPage < totalPages + 1) {
        const results: any = await response;
        totalPages = parseInt(results.data.meta.page.totalPages);
        nextPageLink = results.data.links.next;
      }

      requests.push(response);
      currentPage++;
    }

    return Promise.all(requests);
  },

  getSingle(tenantUUID: string, ruleUUID: string): Promise<any> {
    return axiosLimiter.get(
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenantUUID +
        '/rules/' +
        ruleUUID
    );
  },

  createRule(tenantUUID: string, attributes: any): Promise<any> {
    const body = {
      data: {
        type: 'rules',
        attributes,
      },
    };

    return axiosLimiter.post(
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenantUUID +
        '/rules',
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/vnd.api+json' } }
    );
  },

  updateRule(
    tenantUUID: string,
    ruleUUID: string,
    attributes: any
  ): Promise<any> {
    const body = {
      data: {
        id: ruleUUID,
        type: 'rules',
        attributes,
      },
    };

    return axiosLimiter.patch(
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenantUUID +
        '/rules/' +
        ruleUUID,
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/vnd.api+json' } }
    );
  },

  deleteRule(
    tenantUUID: string,
    ruleUUID: string,
    removeActionEntities = true
  ): Promise<any> {
    const query =
      '?removeActionEntities=' + encodeURIComponent(removeActionEntities);

    return axiosLimiter.delete(
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenantUUID +
        '/rules/' +
        ruleUUID +
        query
    );
  },
};
